export function publicEnv(name) {
    if (typeof window !== "undefined") {
        return window.NEXT_PUBLIC[name];
    } else {
        return process.env[`NEXT_PUBLIC_${name}`];
    }
}
